module.exports = __webpack_public_path__ + "img/telephone.a4fcb142.png";